/**
 * Production kill switch for recurring donations.
 *
 * `features.fullGivingRecord` only means the donor has the paid giving record.
 * It must not also turn recurring donations on. This flag does that, and it
 * defaults off: a build shows the feature only when the env value is exactly
 * "true".
 *
 * Production (`.env.production`, `npm run build:prod`, donor.swiftaid.co.uk)
 * sets it to false. Development and mock-api builds set it to true, so staging
 * previews and local work can still exercise the feature. Turning it on for
 * production is a separate change to `.env.production` and a production rebuild.
 */
export function recurringDonationsEnabled(): boolean {
  // Unit tests are not a production build. They opt in so composable specs
  // still exercise the client. Playwright uses the mock-api env, which is on.
  if (import.meta.env.MODE === 'test') return true
  return import.meta.env.VITE_RECURRING_DONATIONS_ENABLED === 'true'
}
